import Button from '@rio-cloud/rio-uikit/Button';
import { useIntl } from 'react-intl';

import { buildFleetMonitorVehicleUrl } from '#utils/fleetMonitor.util.ts';

import { config } from '../../../config';

type TourVehicleFleetMonitorLinkProps = {
    vehicleAssetId: string;
};

export const TourVehicleFleetMonitorLink = ({ vehicleAssetId }: TourVehicleFleetMonitorLinkProps) => {
    const intl = useIntl();
    const fleetMonitorUrl = buildFleetMonitorVehicleUrl(config.fleetMonitorUrl, vehicleAssetId);
    const openFleetMonitorLabel = intl.formatMessage({
        id: 'intl-msg:ordercom-cloud-frontend.tours.details.vehicle.open-fleet-monitor',

        defaultMessage: 'Open in Fleet Monitor',
    });
    const showOnMapLabel = intl.formatMessage({
        id: 'intl-msg:ordercom-cloud-frontend.tours.details.vehicle.show-on-map',

        defaultMessage: 'Show on map',
    });

    return (
        <Button
            as='a'
            bsStyle={Button.DEFAULT}
            autoTrackingKey='intl-msg:ordercom-cloud-frontend.tours.details.vehicle.show-on-map'
            aria-label={openFleetMonitorLabel}
            data-testid='tour-details-fleet-monitor-link'
            href={fleetMonitorUrl}
            rel='noreferrer'
            target='_blank'
            title={openFleetMonitorLabel}
            iconName='map-location'
        >
            {showOnMapLabel}
        </Button>
    );
};
